var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"product-options",class:{'product-options--product-card': _vm.isProductCard}},_vm._l((_vm.computedOptions),function(option,i){return _c('ProductOption',{key:i,staticClass:"product-options__item",attrs:{"link":_vm.link,"data":option,"is-product-card":_vm.isProductCard}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }